import { useCallback } from 'react';

import { absenceService } from '@/api/domains/absence/absence.service';
import { useExport } from '@/hooks/ui/useExport';
import { getAPIFormat } from '@/types/fileExport.types';
import type { UIExportFormat } from '@/types/fileExport.types';
import type { AbsenceType, AbsenceStatus } from '@/api/domains/absence/absence.types';


export interface UseAbsenceExportParams {
  startDate: string;
  endDate: string;
  absenceType: AbsenceType;
  status: AbsenceStatus;
}

export interface UseAbsenceExportResult {
  exportAbsences: (format: UIExportFormat) => Promise<void>;
  isExporting: boolean;
}

export function useAbsenceExport(
  params: UseAbsenceExportParams,
): UseAbsenceExportResult {
  const { onExport: exportFile, isExporting } = useExport<UIExportFormat>({
    exportFn: (format) => absenceService.exportAbsences({
      startDate: params.startDate,
      endDate: params.endDate,
      absenceType: params.absenceType,
      status: params.status,
      format: getAPIFormat(format),
    }),
  });

  const exportAbsences = useCallback(
    async (format: UIExportFormat) => {
      await exportFile(format);
    },
    [exportFile],
  );

  return { exportAbsences, isExporting };
}
